import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_BRAND_PAGE_CONTENT } from '../constants';
import { brandPageContentSuccess, brandPageContentError } from '../redux/Actions/BrandPageAction';
export function* brandPageContentCall(data) {
    let result = {};
    const { payload: { object: { getEntries }, }, payload: { contentFull }, } = data;
    let responseObj;
    try {
        responseObj = yield call(getEntries, contentFull);
        if (responseObj) {
            result = { ...result, headerData: responseObj.items[0].fields };
            yield put(brandPageContentSuccess(result));
        }
    }
    catch (err) {
        yield put(brandPageContentError());
    }
    if (!responseObj) {
        yield put(brandPageContentError());
    }
}
export function* brandPageSaga() {
    yield takeLatest(GET_BRAND_PAGE_CONTENT, brandPageContentCall);
}
export default brandPageSaga();
